(function () {
  function cartLink() {
    return document.querySelector('#cart-icon-bubble') || document.querySelector('.header__icon--cart');
  }

  function setBubble(count) {
    var link = cartLink();
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        var s = document.createElement('span');
        s.setAttribute('aria-hidden', 'true');
        bubble.appendChild(s);
        link.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count < 100 ? count : '99+';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function feedback(btn) {
    var span = btn.querySelector('span:not(.sold-out-message)') || btn;
    if (btn.getAttribute('data-orig-text') === null || btn.getAttribute('data-orig-text') === undefined) {
      btn.setAttribute('data-orig-text', span.textContent.trim());
    }
    span.textContent = 'Eklendi \u2713';
    btn.classList.add('is-added');
    clearTimeout(btn._addTmr);
    btn._addTmr = setTimeout(function () {
      span.textContent = btn.getAttribute('data-orig-text');
      btn.classList.remove('is-added');
    }, 1800);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      var qa = form.closest('.card-wrapper .quick-add');
      if (!qa) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      // Dawn'ın drawer açan submit handler'ını engelle
      e.preventDefault();
      e.stopPropagation();

      var btn = form.querySelector('[name="add"]');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
      }

      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res && res.status) {
            // hata (ör. stok yok) - sessizce geri al
            throw res;
          }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          setBubble(cart.item_count);
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            feedback(btn);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function () {
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          }
        });
    },
    true // capture
  );
})();
